import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-50750084"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tap-bar"
};
const _hoisted_2 = ["src"];
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import analyseSvg from '@/assets/image/mobile/analyse.svg';
import analyseSvgActive from '@/assets/image/mobile/analyse_active.svg';
import profileSvg from '@/assets/image/mobile/profile.svg';
import profileSvgActive from '@/assets/image/mobile/profile_active.svg';
import useUserPermissions from '@/hooks/useUserPermissions';
import { showFailToast } from 'vant';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const active = ref(route.path);
    const partner_code = localStorage.getItem('ws_partner_code');
    // 是否有【 报告管理 】的权限
    const hasReportManagementPermission = useUserPermissions('pms:report_management');
    // 导航数据
    const tabBarData = ref([{
      text: '分析',
      image: analyseSvg,
      imageActive: analyseSvgActive,
      path: '/analyse',
      isShow: hasReportManagementPermission.value ? true : false
    }, {
      text: '我的',
      image: profileSvg,
      imageActive: profileSvgActive,
      path: '/profile',
      isShow: true
    }]);
    if (!hasReportManagementPermission.value) {
      showFailToast('无报告查看权限，请联系管理员处理！');
    }
    watch(route, newVal => {
      active.value = newVal.path;
    });
    return (_ctx, _cache) => {
      const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
      const _component_van_tabbar = _resolveComponent("van-tabbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_tabbar, {
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => active.value = $event),
        "active-color": "#125ffb",
        "inactive-color": "#adb3ba"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabBarData.value, item => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: item.text
          }, [item.isShow ? (_openBlock(), _createBlock(_component_van_tabbar_item, {
            key: 0,
            to: {
              path: item.path,
              query: {
                partner_code: _unref(partner_code)
              }
            },
            name: item.path
          }, {
            icon: _withCtx(() => [_createElementVNode("img", {
              src: item.path === active.value ? item.imageActive : item.image,
              alt: ""
            }, null, 8, _hoisted_2)]),
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.text), 1)]),
            _: 2
          }, 1032, ["to", "name"])) : _createCommentVNode("", true)], 64);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};